<template>
    <el-select v-model="countryCodeValue"
               ref="selectCountryCode"
               filterable
               placeholder="選擇國碼"
               popper-class="calculator-country-code"
               :disabled="disabled"
               @visible-change="removeReadOnly()"
               @blur="removeReadOnly()"
               @focus="removeReadOnly()"
               @input="updateValue">
        <el-option
                v-for="item in countryCodeOptions"
                :key="item.key"
                :label="item.enName+item.code"
                :value="item.enName+item.code">
        </el-option>
    </el-select>

</template>

<script>
import countryCode from "@/json/country_code.json";
    export default {
        name: "CountryCodeSelect",
        props: {
            countryCodeData: {default: () => ({})},
            disabled:{default: false},
        },
        data() {
            return {
                countryCodeValue: this.countryCodeData.enName+this.countryCodeData.code, //電話國碼預設台灣
                countryCodeOptions: [],
            }
        },
        created() {
            //載入所有國家選項
            this.countryCodeOptions = countryCode.map((d, index) => { return { 'enName': d.countryEnName, 'cnName': d.countryCnName, 'code': d.countryCode, 'countryEnNameCode': d.countryEnName+d.countryCode, 'key': index} })
        },
        mounted() {
            //IOS會無法出現小鍵盤
            this.removeReadOnly()
        },
        watch: {
            countryCodeValue(val) {
                this.$emit('update:modelValue', val)
            },
            modelValue(val) {
                this.countryCodeValue = val
            }
        },
        methods: {
            updateValue(val) {
                this.$emit('input', val); // 通知父元件更新
            },
            removeReadOnly() {
                let [enName, code] = this.countryCodeValue.split("+");
                let countryCode = "+"+code
                let countryCodeData = this.countryCodeOptions.find(item => item.code === countryCode && item.enName === enName) || {};
                this.$nextTick(() => {
                    const inputEl = this.$refs.selectCountryCode.$el.querySelector("input");
                    if (inputEl) {
                        inputEl.removeAttribute("readonly");
                        inputEl.setAttribute('inputmode', 'numeric');
                    }
                });
                this.$emit('visible-change', { enName, countryCodeData })
            },
        },
    }
</script>

<style lang="less" scoped>
    //國碼下拉選擇
    .el-select{
        flex: 0 0 90px;
        width: 90px;
        /deep/.el-input__inner{
            padding: 0 0 0 15px;
            background: none;
            border: none;
            &::placeholder{
                font-size: 14px;
            }
        }
        /deep/.el-input__suffix{
            right: 0;
            @media(max-width: 767px){
                right: -2px;
            }
            .el-select__caret{
                width: 14px;
            }
        }
        /deep/.is-disabled .el-input__inner{
            color: #606266;
        }
        &+.input{
            width: inherit;
        }
    }
</style>